export const NAME = 'sessions';



// WEBPACK FOOTER //
// ./src/modules/sessions/constants.js